import { render } from "./HeaderMainView.vue?vue&type=template&id=38188f81"
import script from "./HeaderMainView.vue?vue&type=script&lang=js"
export * from "./HeaderMainView.vue?vue&type=script&lang=js"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__